<template>
  <div class="diadin">
   
    <el-form :inline="true" :model="formInline" class="demo-form-inline">
      <el-form-item>
        <el-input
          style="width: 300px"
          clearable
          :placeholder="$t('menu.mubanmingcheng')"
          v-model="formInline.title"
        ></el-input>
      </el-form-item>

      <el-form-item>
        <el-select v-model="orderType" :placeholder="$t('menu.yewylixinbg')" clearable>
          <el-option
            v-for="(item, index) in odtype"
            :key="index"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-select
          v-model="formInline.type"
          :placeholder="$t('menu.State')"
          clearable
        >
          <el-option
            v-for="(item, index) in jsfs"
            :key="index"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="onSubmit">{{
          $t("menu.search")
        }}</el-button>
      </el-form-item>
    </el-form>
 <div
      style="
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 20px;
      "
    >
 <div
        @click="erpzd()"
        style="
          background-color: #5bacff;
          padding: 10px 20px;
          color: #fff;
          border-radius: 5px;
          cursor: pointer;
        "
      >
        ＋ {{$t('menu.addfeiyongmb')}}
      </div>
      <div>
       <!-- {{$t('menu.mubantishi')}} -->
      </div>
    
    </div>
    <el-table
      empty-text=" "
      :data="mation"
      style="width: 100%"
      border
      highlight-current-row
    >
     
      <el-table-column prop="pc" :label="$t('menu.mubanmingcheng')">
        <template slot-scope="scope">
          <div>
            {{ scope.row.name }}
          </div>
          <div>
            {{ scope.row.nameEn }}
          </div>
          <div>
            {{ scope.row.nameDe }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="cjh" :label="$t('menu.yewylixinbg')">
        <template slot-scope="scope">
          <div>{{ pdlsh(scope.row.businessType) }}</div>
        </template>
      </el-table-column>

      <el-table-column
        prop="transportUnitAmount"
        :label="$t('menu.zhesyunshu')"
        width="80"
      ></el-table-column>
      <el-table-column
        prop="handlingUnitAmount"
        :label="$t('menu.zheshibanyun')"
        width="80"
      ></el-table-column>
      <el-table-column
        prop="certificateUnitAmount"
        :label="$t('menu.zheshizhengshu')"
        width="80"
      ></el-table-column>
      
      <el-table-column prop="status" :label="$t('menu.State')" width="80">
        <template slot-scope="scope">
          <div>{{ pdlsha(scope.row.status) }}</div>
        </template>
      </el-table-column>

      <el-table-column>
        <template slot="header" slot-scope="scope">
          <div>{{ $t("menu.Operation") }}</div>
        </template>
        <template slot-scope="scope">
          <el-button type="text" size="mini" @click="eEdit(scope.row)"
            >{{ $t("menu.Edit") }}
          </el-button>
          <el-button v-if="scope.row.status==1" type="text" size="mini" @click="handleEdit(0, scope.row)"
            >{{ $t("menu.zhesty") }}</el-button
          >
          <el-button v-else type="text" size="mini" @click="handleEdit(1, scope.row)"
            >{{ $t("menu.zhesqiy") }}</el-button
          >
          <el-button type="text" size="mini" @click="delseac( scope.row.id)"
            >{{ $t("menu.Delete") }}</el-button
          >
        
        </template>
      </el-table-column>
    </el-table>

    <div class="bottompage">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage3"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total,sizes, prev, pager, next"
        :total="totale"
      >
      </el-pagination>
    </div>
    <el-dialog
      :title="$t('menu.chuangjainmban')"
      :visible.sync="dialogVisiblea"
      v-if="dialogVisiblea"
      width="700px"
      :before-close="handleClose"
    >
      <div style="margin: 0 auto">
        <div
          style="
            display: flex;
            font-weight: bold;
            align-items: flex-start;
            border-top: 1px solid #ebf0fa;
            padding: 10px 0;
          "
        >
         
          <div
            style="
              width: 4px;
              height: 20px;
              background-color: #409eff;
              margin-right: 10px;
            "
          ></div>
          {{$t('menu.Basicinformation')}}
        </div>
        <div style="margin-bottom: 10px"> {{$t('menu.mubanmingcheng')}}</div>
        <div style="display: flex; align-items: center; width: 100%">
          <div style="width: 500px; margin-right: 20px">
            <div
              style="display: flex; align-items: center; margin-bottom: 10px"
            >
              <div style="width: 80px">中文</div>
              <el-input
                placeholder=""
                v-model="erpform.name"
                maxlength="100"
                show-word-limit
                clearable
              >
              </el-input>
            </div>
            <div
              style="display: flex; align-items: center; margin-bottom: 10px"
            >
              <div style="width: 80px">English</div>
              <el-input
                placeholder=""
                v-model="erpform.nameEn"
                maxlength="100"
                show-word-limit
                clearable
              >
              </el-input>
            </div>
            <div
              style="display: flex; align-items: center; margin-bottom: 10px"
            >
              <div style="width: 80px">Deutsch</div>
              <el-input
                placeholder=""
                v-model="erpform.nameDe"
                maxlength="100"
                show-word-limit
                clearable
              >
              </el-input>
            </div>
          </div>
          <div
            style="
              width: 180px;
              height: 150px;
              background-color: #e5eaf8;
              padding: 10px;
              box-sizing: border-box;
            "
          >
            <div style="margin-bottom: 10px">{{$t('menu.shuoming')}}</div>
            <div>
             {{$t('menu.zheshitishia')}}
            </div>
          </div>
        </div>
       

        <div style="margin: 10px 0; display: flex">
          <div style="margin-right: 20px">
            <div style="margin-bottom: 10px">{{$t('menu.yewylixinbg')}}</div>
            <div>
              <el-select
                v-model="erpform.businessType"
                :placeholder="$t('menu.yewylixinbg')"
                clearable
              >
                <el-option
                  v-for="(item, index) in odtype"
                  :key="index"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </div>
          </div>
         
        </div>
        <div>
          <div>{{$t('menu.State')}}</div>
          <div style="margin: 10px 0">
            <el-radio v-model="erpform.status" label="1">{{$t('menu.zhesqiy')}}</el-radio>
            <el-radio v-model="erpform.status" label="0">{{$t('menu.zhesty')}}</el-radio>
          </div>
        </div>

        <div
          style="
            display: flex;
            font-weight: bold;
            align-items: flex-start;
            border-top: 1px solid #ebf0fa;
            padding: 10px 0;
          "
        >
          <div
            style="
              width: 4px;
              height: 20px;
              background-color: #409eff;
              margin-right: 10px;
            "
          ></div>
          {{$t('menu.feiyongmingx')}}
        </div>
    
        <div>
          <div style="display: flex; align-items: center; margin-bottom: 10px">
            <div style="width: 80px">{{$t('menu.zhesyunshu')}}</div>
            <el-input
              placeholder=""
              v-model="erpform.transportUnitAmount"
              clearable
            >
            </el-input>
          </div>
          <div style="display: flex; align-items: center; margin-bottom: 10px">
            <div style="width: 80px">{{$t('menu.zheshibanyun')}}</div>
            <el-input
              placeholder=""
              v-model="erpform.handlingUnitAmount"
              clearable
            >
            </el-input>
          </div>
          <div style="display: flex; align-items: center; margin-bottom: 10px">
            <div style="width: 80px">{{$t('menu.zheshizhengshu')}}</div>
            <el-input
              placeholder=""
              v-model="erpform.certificateUnitAmount"
              clearable
            >
            </el-input>
          </div>
        </div>
        <div >
          <el-button type="primary" @click="updata()">{{$t('menu.Confirm')}}</el-button>
        </div>
      </div>
    </el-dialog>
      <el-dialog
      :title="$t('menu.chuangjainmban')"
      :visible.sync="dialogVisibleaa"
      v-if="dialogVisibleaa"
      width="700px"
      :before-close="handleClose"
    >
      <div style="margin: 0 auto">
        <div
          style="
            display: flex;
            font-weight: bold;
            align-items: flex-start;
            border-top: 1px solid #ebf0fa;
            padding: 10px 0;
          "
        >
         
          <div
            style="
              width: 4px;
              height: 20px;
              background-color: #409eff;
              margin-right: 10px;
            "
          ></div>
          {{$t('menu.Basicinformation')}}
        </div>
        <div style="margin-bottom: 10px"> {{$t('menu.mubanmingcheng')}}</div>
        <div style="display: flex; align-items: center; width: 100%">
          <div style="width: 500px; margin-right: 20px">
            <div
              style="display: flex; align-items: center; margin-bottom: 10px"
            >
              <div style="width: 80px">中文</div>
              <el-input
                placeholder=""
                v-model="erpform.name"
                maxlength="100"
                show-word-limit
                clearable
              >
              </el-input>
            </div>
            <div
              style="display: flex; align-items: center; margin-bottom: 10px"
            >
              <div style="width: 80px">English</div>
              <el-input
                placeholder=""
                v-model="erpform.nameEn"
                maxlength="100"
                show-word-limit
                clearable
              >
              </el-input>
            </div>
            <div
              style="display: flex; align-items: center; margin-bottom: 10px"
            >
              <div style="width: 80px">Deutsch</div>
              <el-input
                placeholder=""
                v-model="erpform.nameDe"
                maxlength="100"
                show-word-limit
                clearable
              >
              </el-input>
            </div>
          </div>
          <div
            style="
              width: 180px;
              height: 150px;
              background-color: #e5eaf8;
              padding: 10px;
              box-sizing: border-box;
            "
          >
            <div style="margin-bottom: 10px">{{$t('menu.shuoming')}}</div>
            <div>
             {{$t('menu.zheshitishia')}}
            </div>
          </div>
        </div>
       

        <div style="margin: 10px 0; display: flex">
          <div style="margin-right: 20px">
            <div style="margin-bottom: 10px">{{$t('menu.yewylixinbg')}}</div>
            <div>
              <el-select
                v-model="erpform.businessType"
                :placeholder="$t('menu.yewylixinbg')"
                clearable
              >
                <el-option
                  v-for="(item, index) in odtype"
                  :key="index"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </div>
          </div>
         
        </div>
        <div>
          <div>{{$t('menu.State')}}</div>
          <div style="margin: 10px 0">
            <el-radio v-model="erpform.status" label="1">{{$t('menu.zhesqiy')}}</el-radio>
            <el-radio v-model="erpform.status" label="0">{{$t('menu.zhesty')}}</el-radio>
          </div>
        </div>

        <div
          style="
            display: flex;
            font-weight: bold;
            align-items: flex-start;
            border-top: 1px solid #ebf0fa;
            padding: 10px 0;
          "
        >
          <div
            style="
              width: 4px;
              height: 20px;
              background-color: #409eff;
              margin-right: 10px;
            "
          ></div>
          {{$t('menu.feiyongmingx')}}
        </div>
    
        <div>
          <div style="display: flex; align-items: center; margin-bottom: 10px">
            <div style="width: 80px">{{$t('menu.zhesyunshu')}}</div>
            <el-input
              placeholder=""
              v-model="erpform.transportUnitAmount"
              clearable
            >
            </el-input>
          </div>
          <div style="display: flex; align-items: center; margin-bottom: 10px">
            <div style="width: 80px">{{$t('menu.zheshibanyun')}}</div>
            <el-input
              placeholder=""
              v-model="erpform.handlingUnitAmount"
              clearable
            >
            </el-input>
          </div>
          <div style="display: flex; align-items: center; margin-bottom: 10px">
            <div style="width: 80px">{{$t('menu.zheshizhengshu')}}</div>
            <el-input
              placeholder=""
              v-model="erpform.certificateUnitAmount"
              clearable
            >
            </el-input>
          </div>
        </div>
        <div >
          <el-button type="primary" @click="updataed()">{{$t('menu.Confirm')}}</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { log } from "i18n-jsautotranslate";
import {
  costlist,
  poFeeTemplateOfDealer,
  poFeeTemplateOfDealera,
  poFeeTempdele
} from "../../api/api";

export default {
  data() {
    return {
      radio: "1",
      staue: [
        {
          name: this.$t("menu.All"),
          num: 0,
          id: "99",
        },
        {
          name: this.$t("menu.PendingReview"),
          num: 0,
          id: "1",
        },
        {
          name: this.$t("menu.daizhid"),
          num: 0,
          id: "5",
        },
        {
          name: this.$t("menu.PendingShipment"),
          num: 0,
          id: "2",
        },
        {
          name: this.$t("menu.UnderDelivery"),
          num: 0,
          id: "3",
        },
        {
          name: this.$t("menu.Completed"),
          num: 0,
          id: "4",
        },
        // {
        //   name: '待支付',
        //   num: 2,
        //   id: '0',
        // },
        {
          name: this.$t("menu.Rejected"),
          num: 0,
          id: "-2",
        },
        {
          name: this.$t("menu.Cancelled"),
          num: 0,
          id: "-1",
        },
      ],
      jsfs: [
        {
          name: "启用",
          num: 0,
          id: "1",
        },
        {
          name: "停用",
          num: 0,
          id: "0",
        },
      ],
      currentPage3: 1,
      pageSize: 10,
      totale: 3,
      erpform: {
        name: "",
        nameDe: "",
        nameEn: "",
        businessType: "",
        currencyType: "",
        status: "1",
        transportUnitAmount: "",
        handlingUnitAmount: "",
        certificateUnitAmount: "",
      },
      dialogVisiblea: false,
      dialogVisibleaa:false,
      dialogjs: false,
      dialogdy: false,
      bz: "",
      orderType: "",
      mation: [], //列表
      formInline: {
        title: "",
        startTime: "",
        endTime: "",
        contact: "",
        category: "",
        retailerId: "",
        type: "",
        staue: "",
        data1: "",
        data2: "",
      },
      formInlineac: {
        title: "",
      },
      jsdata: {
        settleAmount: "",
        remarks: "",
        id: "",
      },
      inle: "zh",
      odtype: [
        {
          name: "二轮配件",
          num: 0,
          id: "1",
        },
        {
          name: "二轮整车",
          num: 0,
          id: "2",
        },
        {
          name: "四轮配件",
          num: 0,
          id: "3",
        },
        {
          name: "四轮整车",
          num: 0,
          id: "4",
        },
        {
          name: "周边品",
          num: 0,
          id: "9000",
        },
      ],
      acclist: [],
      typin: 0,
      lslis: [],
      mationac: [],
      multipleSelection: [],
      matinfo: {},
      cartypelist: [],
    };
  },
  created() {
    let a = sessionStorage.getItem("i18n");
    this.typin = sessionStorage.getItem("platform");
    this.inle = a;


    this.biao();
  },
  methods: {
    pdlsh(e) {
      let a = this.odtype;
      let c = "";
      a.forEach((z) => {
        if (z.id == e) {
          c = z.name;
        }
      });
      return c;
    },

    pdlsha(e) {
      let a = this.jsfs;
      let c = "";
      a.forEach((z) => {
        if (z.id == e) {
          c = z.name;
        }
      });
      return c;
    },

    erpzd() {
      this.dialogVisiblea = true;
    },

    async updata() {
      // if(this.jsdata.settleAmount==''){
      //            this.$message.error('请填写结算金额')
      //            return false
      //         }
      let param = this.erpform;

      const { data: res } = await poFeeTemplateOfDealer(param);
      if (res.code == "500") {
        this.$message.error(res.msg);
      } else {
        this.$message.success("成功");
        this.handleClose();
        this.biao();
      }
    },
    async updataed() {
      // if(this.jsdata.settleAmount==''){
      //            this.$message.error('请填写结算金额')
      //            return false
      //         }
      let param = this.erpform;

      const { data: res } = await poFeeTemplateOfDealera(param);
      if (res.code == "500") {
        this.$message.error(res.msg);
      } else {
        this.$message.success("成功");
        this.handleClose();
        this.biao();
      }
    },
    
    ctype(e) {
      let a = "";
      this.acclist.forEach((z) => {
        if (z.id == e) {
          a = z.currencyName;
        }
      });
      return a;
    },
    handleClose() {
      this.erpform = {
        name: "",
        nameDe: "",
        nameEn: "",
        businessType: "",
        currencyType: "",
        status: "1",
        transportUnitAmount: "",
        handlingUnitAmount: "",
        certificateUnitAmount: "",
      };
      this.dialogVisibleaa=false
      this.dialogVisiblea = false;
      this.biao()
    },

    async biao() {
      let param = new URLSearchParams();

      const { data: res } = await costlist(
        param,
        this.currentPage3,
        this.pageSize,
        sessionStorage.getItem("userId"),
        this.formInline.title,
         this.orderType,
         this.formInline.type
      );
      console.log(res);
      
      this.mation = res.rows;
      this.totale = res.total;
    },
    eEdit(row) {
      
        this.erpform = {
          id:row.id,
          name: row.name,
          nameDe: row.nameDe,
          nameEn: row.nameEn,
          dealerId: row.dealerId,
          businessType: row.businessType+'',
          status: row.status+'',
          transportUnitAmount: row.transportUnitAmount,
          handlingUnitAmount: row.handlingUnitAmount,
          certificateUnitAmount: row.certificateUnitAmount,
      };
      this.dialogVisibleaa=true
    },
    //表单点击
   async handleEdit(index, row) {
      let a = {
          id:row.id,
          name: row.name,
          nameDe: row.nameDe,
          nameEn: row.nameEn,
            dealerId: row.dealerId,
          businessType: row.businessType+'',
          status: index+'',
          transportUnitAmount: row.transportUnitAmount,
          handlingUnitAmount: row.handlingUnitAmount,
          certificateUnitAmount: row.certificateUnitAmount,
      };
        let param = a

      const { data: res } = await poFeeTemplateOfDealera(param);
      if (res.code == "500") {
        this.$message.error(res.msg);
      } else {
        this.$message.success("成功");
        
        this.biao();
      }
    },
   async delseac(e){
      
       let param=''
       const { data: res } = await poFeeTempdele(param,e)
        if (res.code !== 200) return this.$message.error(res.msg)
        this.$message({
          message: '删除成功',
          type: 'success'
        });
        
        this.biao()
    },
    //搜索
    onSubmit() {
      this.biao();
    },

    handleSizeChange(val) {
      this.pageSize = val;
      // console.log(`每页 ${val} 条`)
      this.biao();
    },
    handleCurrentChange(val) {
      this.currentPage3 = val;
      this.biao();
    },
  },
};
</script>

<style lang="less" scoped>
.diadin {
  width: 100%;
  min-height: 80vh;
  background-color: #fff;
  padding: 20px;
  padding-left: 0;
}

.bottompage {
  display: flex;
  justify-content: flex-end;
  padding-top: 20px;
}

/deep/.el-table {
  min-height: 750px !important;
}

/deep/.el-table__body td {
  padding: 20px !important;
  padding-left: 0 !important;
  text-align: left;
}

/deep/.el-table th.is-leaf {
  text-align: left;
}

/deep/.el-tabs {
  height: 97%;
  width: 100%;
}

/deep/.el-tabs__content {
  width: 100%;
  height: 100%;
}

/deep/.el-table--scrollable-x .el-table__body-wrapper {
  height: 90%;
}

/deep/.el-tab-pane {
  height: 82%;
}

/deep/.el-table--fit {
  height: 94%;
}
</style>
